import ExtendableError from './ExtendableError';

class GoogleAccountMismatchError extends ExtendableError {}

export default GoogleAccountMismatchError;
